import React from 'react';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import './App.css';
import { CryptoProvider } from './context/CryptoContext';
import Navbar from './components/Navbar';
import MarketStatsBar from './components/MarketStatsBar';
import WatchlistDrawer from './components/WatchlistDrawer';
import CryptoHome from './Pages/CryptoHome';
import CryptoDetail from './Pages/CryptoDetail';
import About from './Pages/About';
import Contact from './Pages/Contact';
import { LogoIcon } from './icons/icons';
import { Link } from 'react-router-dom';

function App() {
  return (
    <CryptoProvider>
      <Router>
        <div className="min-h-screen bg-dark-950 text-slate-100 flex flex-col selection:bg-cyan-500/30 selection:text-cyan-200">
          {/* Global Sticky Navigation */}
          <Navbar />

          {/* Global Market Stats Ticker */}
          <MarketStatsBar />

          {/* Watchlist Slide-out Drawer */}
          <WatchlistDrawer />

          {/* Main Application Routes */}
          <div className="flex-1">
            <Routes>
              <Route path="/" element={<CryptoHome />} />
              <Route path="/coin/:id" element={<CryptoDetail />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
            </Routes>
          </div>

          {/* Futuristic Platform Footer */}
          <footer className="mt-auto border-t border-slate-800/80 bg-dark-950/90 py-8 text-xs text-slate-400">
            <div className="wrapper-container flex flex-col sm:flex-row items-center justify-between gap-4">
              <div className="flex items-center gap-2">
                <LogoIcon className="w-6 h-6" />
                <span className="font-extrabold text-slate-200 text-sm">
                  Crypto<span className="text-gradient-cyan">Pulse</span>
                </span>
                <span className="text-slate-600 font-mono text-[11px]">v2.0 PRO</span>
              </div>

              <div className="flex items-center gap-4 sm:gap-6 text-slate-400 flex-wrap justify-center">
                <Link to="/" className="hover:text-cyan-400 transition-colors">
                  Markets
                </Link>
                <span>•</span>
                <Link to="/about" className="hover:text-cyan-400 transition-colors">
                  About
                </Link>
                <span>•</span>
                <Link to="/contact" className="hover:text-cyan-400 transition-colors">
                  Contact
                </Link>
                <span>•</span>
                <span>Multi-Currency Terminal</span>
                <span>•</span>
                <span className="text-emerald-400 flex items-center gap-1">
                  <span className="inline-block w-2 h-2 rounded-full bg-emerald-400 animate-pulse"></span>
                  Systems Operational
                </span>
              </div>
            </div>
          </footer>
        </div>
      </Router>
    </CryptoProvider>
  );
}

export default App;
